'use client'

import { useEffect } from 'react'
import ErrorState from '@/components/ErrorState'
import { isChunkLoadError, recoverFromChunkError } from '@/lib/chunkError'

export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const chunkError = isChunkLoadError(error)

  useEffect(() => {
    console.error('[AppError]', error)
  }, [error])

  useEffect(() => {
    // Chunk errors can't be reset (webpack caches the failed promise), so reload
    // once we're online. Other errors recover when connectivity returns.
    if (chunkError) {
      return recoverFromChunkError()
    }
    window.addEventListener('online', reset)
    return () => window.removeEventListener('online', reset)
  }, [chunkError, reset])

  // For chunk errors, "Try again" must reload rather than reset.
  return (
    <ErrorState
      error={error}
      reset={chunkError ? () => window.location.reload() : reset}
    />
  )
}
